import { Popper } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import { del } from '../../../core/client';
import { useAppSelector } from '../../../store';
import { setPage, getEvents } from '../../../store/features/moments/momentsSlice';
import DeleteWarningModal from '../create-actions/deleteWarningModal';
import ModalDialog from '../create-actions/modal';
import EmployeeCard from '../my-teams/employeeCard';

const Card01 = ({ data }: any) => {
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState<boolean>(false);
    const [deleteWraningModal, setDeleteWraningModal] = useState<boolean>(false);
    const [deleteId, setDeleteId] = useState<any>('');
    const { filter, tuttorialIndex, aside, eventList } = useAppSelector(state => state.moments);
    const { words } = useAppSelector(state => state.localization);


    const photo = eventList.feedUsersPhoto.find(item => item?.id === data?.userId)?.photo;
    const date = new Date(data?.specialDateStartDate);
    const spiecalDate = date?.toLocaleDateString('tr-TR');

    const actionDeleteId = (id: any) => {
        setShowModal(true);
        const acitonDelete = data?.actionList?.find(x => x?.speicalDayActionId === id);
        setDeleteId(acitonDelete);
    };

    const deleteWarningOpenModal = () => {
        setDeleteWraningModal(true);
    };

    const deleteActions = async () => {
        await del(`specialdate-action/delete?id=${deleteId?.speicalDayActionId}`, '').then((res: any) => {
            if (res.data.isSuccessful) {
                dispatch(getEvents(filter));
            }
        });
    };
    const CustomPopper = function (props) {
        return <Popper {...props} className="tooltip-01" placement="right" />;
    };

    return (
        <>
            <div className={tuttorialIndex === 2 ? 'micro-card-01 tutorial-active' : 'micro-card-01'}>
                <div className="c-item-01">
                    <Tooltip
                        placement="top"
                        title={
                            !aside?.allEmployeesLoading ? (
                                <EmployeeCard
                                    employee={
                                        aside?.allEmployees?.length > 0
                                            ? aside?.userTeams?.find(employee => employee?.id === data?.userId) ||
                                              aside?.allEmployees?.find(employee => employee?.id === data?.userId)
                                            : null
                                    }
                                />
                            ) : (
                                ''
                            )
                        }
                        PopperComponent={CustomPopper}
                        enterDelay={500}
                        leaveDelay={2000}>
                        <Link to={data?.userId ? '/profile?u=' + data?.userId : '!#'}>
                            {(photo || data?.ecUserId) && (
                                <img
                                    className={photo ? 'c-item-01-A' : 'c-item-01-A BGblack'}
                                    src={photo ? photo : 'https://khicindekocvar.blob.core.windows.net/prod/koc_icon_user.svg'}
                                    alt='https://khicindekocvar.blob.core.windows.net/prod/koc_icon_user.svg'
                                />
                            )}
                        </Link>
                    </Tooltip>
                    <div className="c-item-01-B">
                        <h5 className={data?.ecUserId ? 'c-unit-01' : 'c-unit-01 teams'}>
                            {data.name} {data?.ecUserId && data.surname}
                        </h5>
                        <p className="c-unit-02">{data?.ecUserId && data?.position}</p>
                    </div>
                </div>
                <div className="c-item-02">
                    <div className="c-item-02-A">
                        <div className="c-unit-01">
                            <div className={data.Celebrationtype === 1 ? 'c-unit-01-A' : 'c-unit-01-A Personal'}>
                                {data.icon && <img className="card-icon" src={data.icon} alt='icon' />}
                            </div>
                            <span className="c-unit-01-B">{data.specialDateType}</span>
                        </div>
                        <div className="c-unit-02">
                            <span className="c-unit-02-A">{spiecalDate}</span>
                        </div>
                    </div>
                    {data.actionList.length > 0 ? (
                        <>
                            <Tooltip
                                placement="top"
                                arrow
                                title={words && words['WEB.editPlan']}
                                className="c-item-02-B"
                                onClick={() =>
                                    tuttorialIndex > 0
                                        ? null
                                        : dispatch(
                                              setPage({
                                                  name: 'createAction',
                                                  type: '',
                                                  id: '',
                                                  managerDefinedSpecialDateId: data.managerDefinedSpecialDateId,
                                                  userSpecialDateMainId: data.userSpecialDateMainId,
                                              }),
                                          )
                                }>
                                <a href="#!">
                                    <svg className="light" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18 2L22 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path
                                            d="M7.5 20.5L19 9L15 5L3.5 16.5L2 22L7.5 20.5Z"
                                            stroke="white"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                    <svg className="dark" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18 2L22 6" stroke="#33B5FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path
                                            d="M7.5 20.5L19 9L15 5L3.5 16.5L2 22L7.5 20.5Z"
                                            stroke="#33B5FF"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </a>
                            </Tooltip>
                        </>
                    ) : (
                        <Tooltip
                            placement="top"
                            arrow
                            title={words && words['WEB.createPlan']}
                            className="c-item-02-B"
                            onClick={() =>
                                tuttorialIndex > 0
                                    ? null
                                    : dispatch(
                                          setPage({
                                              name: 'createAction',
                                              type: '',
                                              id: '',
                                              managerDefinedSpecialDateId: data.managerDefinedSpecialDateId,
                                              userSpecialDateMainId: data.userSpecialDateMainId,
                                          }),
                                      )
                            }>
                            <a href="#!">
                                <svg className="light" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
                                        stroke="white"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path d="M12 8V16" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M8 12H16" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <svg className="dark" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
                                        stroke="#00A3FF"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path d="M12 8V16" stroke="#00A3FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M8 12H16" stroke="#00A3FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </a>
                        </Tooltip>
                    )}
                </div>
                <div className="c-item-03">
                    <svg className="c-unit-01" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 10.5L20 15.5L15 20.5" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path
                            d="M4 4.5V11.5C4 12.5609 4.42143 13.5783 5.17157 14.3284C5.92172 15.0786 6.93913 15.5 8 15.5H20"
                            stroke="#6C6C7D"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <span className="c-unit-02">{data.specialDayDescription}</span>
                </div>
                {data.actionList.length > 0 && (
                    <div className="c-item-04">
                        {data.actionList.map((action: any, index) => (
                            <div className="c-item-04-A" key={'actionlist' + index}>
                                {tuttorialIndex > 0 ? (
                                    ''
                                ) : (
                                    <ModalDialog
                                        message={words && words['WEB.sureToDeletePlan']}
                                        open={showModal}
                                        setOpen={setShowModal}
                                        deleteActions={deleteActions}
                                    />
                                )}
                                {action?.regulatoryAuthorityDescription && (
                                    <DeleteWarningModal
                                        message={action?.regulatoryAuthorityDescription}
                                        open={deleteWraningModal}
                                        setOpen={setDeleteWraningModal}
                                    />
                                )}
                                <div className="c-item-04-group">
                                    <strong className="c-unit-01-strong">
                                        {index + 1}. {words && words['WEB.countToPlan']}{' '}
                                    </strong>
                                    <span className="c-unit-01">{action.name}</span>
                                    <div className="c-unit-02">
                                        {tuttorialIndex > 0 ? (
                                            ''
                                        ) : (
                                            <Tooltip
                                                arrow
                                                onClick={() =>
                                                    action?.hasRegulatoryAuthority
                                                        ? actionDeleteId(action?.speicalDayActionId)
                                                        : deleteWarningOpenModal()
                                                }
                                                placement="top"
                                                title={words && words['WEB.delete']}
                                                className="c-unit-02-B">
                                                <a href="#!">
                                                    <svg
                                                        className="light"
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <rect width="24" height="24" fill="white" />
                                                        <path
                                                            d="M3 6H5H21"
                                                            stroke="white"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
                                                            stroke="white"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M10 11V17"
                                                            stroke="white"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M14 11V17"
                                                            stroke="white"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                    <svg
                                                        className="dark"
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <rect width="24" height="24" fill="white" />
                                                        <path
                                                            d="M3 6H5H21"
                                                            stroke="#D3D3D8"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
                                                            stroke="#D3D3D8"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M10 11V17"
                                                            stroke="#D3D3D8"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M14 11V17"
                                                            stroke="#D3D3D8"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </a>
                                            </Tooltip>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </>
    );
};

export default Card01;
